/* eslint-disable react/prop-types */

import React from 'react'
import { Row, Col, DatePicker, Button, Checkbox, TreeSelect } from 'antd'
import { DownloadOutlined } from '@ant-design/icons'

import locale from 'antd/es/date-picker/locale/es_ES'
import moment from 'moment'
import 'moment/locale/es' // without this line it didn't work
moment.locale('es')
const { SHOW_PARENT } = TreeSelect
const { RangePicker } = DatePicker

export function PlotMenu ({
  medios,
  radios,
  handleMedio,
  handleRadio,
  handleDate,
  handleLegend,
  handleDownload,
  currentMedio,
  currentRadio
}) {
  const treeDataMedios = [{
    title: 'Todos los medios',
    value: 'Todos los medios',
    key: 'Todos los medios',
    children: medios.slice(1).map((el) => { return { title: el, value: el, key: el } })
  }]

  const treeDataRadios = [
    {
      title: 'Todas las radios',
      value: 'Todas las radios',
      key: 'Todas las radios',
      children: radios.slice(1).map((el) => { return { title: el, value: el, key: el } })
    }]

  const tPropsMedios = {
    treeData: treeDataMedios,
    value: currentMedio,
    onChange: handleMedio,
    treeCheckable: true,
    treeDefaultExpandAll: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: 'Selecciona Medios',
    style: {
      width: '100%'
    },
    maxTagCount: 'responsive',
    size: 'large',
    virtual: false
  }

  const tPropsRadios = {
    treeData: treeDataRadios,
    value: currentRadio,
    onChange: handleRadio,
    treeCheckable: true,
    treeDefaultExpandAll: true,
    showCheckedStrategy: SHOW_PARENT,
    placeholder: 'Selecciona Radios',
    style: {
      width: '100%'
    },
    maxTagCount: 'responsive',
    size: 'large',
    virtual: false
  }

  return (
    <div className="upper-menu">
      <Row>
        <Col
          xs={{ span: 12, offset: 0, order: 3 }}
          lg={{ span: 3, offset: 0, order: 1 }}
        >
          <div className="label-box">
            <Checkbox
              style={{ fontSize: 'calc(12px + 0.4vw)' }}
              defaultChecked
              onChange={handleLegend}
              className="legend apruebo"
              name="apruebo"
              id="apruebo"
            >
              Apruebo
            </Checkbox>
          </div>
        </Col>

        <Col xs={{ span: 10, order: 4 }} lg={{ span: 3, order: 2 }}>
          <div className="label-box">
            <Checkbox
              style={{ fontSize: 'calc(12px + 0.4vw)' }}
              defaultChecked
              onChange={handleLegend}
              className="legend rechazo"
              name="rechazo"
              id="rechazo"
            >
              Rechazo
            </Checkbox>
          </div>
        </Col>

        <Col
          xs={{ span: 20, offset: 0, order: 1 }}
          lg={{ span: 4, offset: 0, order: 3 }}
          className="select-medios"
        >
          <TreeSelect {...tPropsMedios} />
        </Col>

        <Col
          xs={{ span: 20, offset: 0, order: 1 }}
          lg={{ span: 4, offset: 1, order: 3 }}
          className="select-medios"
        >
          <TreeSelect {...tPropsRadios} />
        </Col>

        <Col
          xs={{ span: 20, offset: 0, order: 1 }}
          lg={{ span: 5, offset: 1, order: 3 }}
          className="select-dates"
        >
          <RangePicker
            picker="week"
            locale={{
              ...locale,
              lang: {
                ...locale.lang,
                rangePlaceholder: ['Empieza', 'Termina']
              }
            }}
            onChange={handleDate}
            size={'medium'}
            style={{ width: '90%', height: '100%' }}
            format={e => {
              const d = e._d
              d.setDate(d.getDate() + 1 - (d.getDay() || 7))
              const day = d.getDate()
              const month = e._locale._months[d.getMonth()]
              const formatted = `${day} - ${
                month.charAt(0).toUpperCase() + month.slice(1)
              }`
              return formatted
            }}
            disabledDate={ (current) => {
              const dateBegin = new Date(2021, 12, 3)
              return current && (current.valueOf() > Date.now() || current.valueOf() < dateBegin.valueOf())
            }}
          />
        </Col>

        <Col
          xs={{ span: 2, offset: 0, order: 2 }}
          lg={{ span: 1, offset: 1, order: 4 }}
        >
          <Button
            type="primary"
            ghost
            icon={<DownloadOutlined onClick={handleDownload} />}
            size="large"
          />
        </Col>
      </Row>
    </div>
  )
}
